import {registerCrudStore} from '@/libs/core/+state/register-crud-store';
import {AiServiceQueueItemModel} from '@/libs/Api';
import {AiServiceQueueItemsDataService} from '@/libs/ai-service-queue-items/ai-service-queue-items-data-service';
import {BusinessModule} from '@/libs/core/models/business-module';

export const aiServiceQueueItemsStore = registerCrudStore<AiServiceQueueItemModel, AiServiceQueueItemModel>(BusinessModule.AiServiceQueueItem, new AiServiceQueueItemsDataService());
